import styled from "styled-components";

export const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

export const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;
export const InputContainer = styled.div`
  position: relative;
  input {
    min-width: 250px;
    :focus {
      border-color: #00000080 !important;
    }
  }
  button {
    position: absolute;
    right: 0px;
  }
`;
